import { FoundStatuses } from "../../../types/FoundItemTypes";
import { permissions } from "../../../utils/constants/permissions";
import { commonLabels } from "../../../utils/constants/labels";

export const foundReportStatus = [
  { value: FoundStatuses.Open, label: commonLabels.found, key: FoundStatuses.Open, permissionKey: permissions.IsFoundStatusEnabled },
  // { value: FoundStatuses.InProcess, label: "In Process", key: FoundStatuses.InProcess },
  { value: FoundStatuses.Prematched, label: commonLabels.preMatch, key: FoundStatuses.Prematched, permissionKey: permissions.IsPreMatchStatusEnabled },
  { value: FoundStatuses.FinalMatch, label: commonLabels.finalMatch, key: FoundStatuses.FinalMatch, permissionKey: permissions.IsFinalMatchStatusEnabled },
  { value: FoundStatuses.ReadyToShip, label: commonLabels.readyToShip, key: FoundStatuses.ReadyToShip, permissionKey: permissions.IsReadyToShipStatusEnabled },
  { value: FoundStatuses.Shipped, label: commonLabels.shipped, key: FoundStatuses.Shipped, permissionKey: permissions.IsShippedStatusEnabled },
  { value: FoundStatuses.Discarded, label: commonLabels.discard, key: FoundStatuses.Discarded, permissionKey: permissions.IsDiscardStatusEnabled },
];

export const allowedFoundStatuses = [FoundStatuses.Open, FoundStatuses.Discarded];

export const filteredFoundReportStatus = foundReportStatus.map((status) => ({
  ...status,
  disabled: !allowedFoundStatuses.includes(status.value), // Disable all except found and discarded
}));

export const transformFoundItemResponse = (response: any) => {
  return {
    id: response.id,
    trackingId: response?.trackingId || "",
    status: response.status ?? 0,
    lostDate: response?.lostDate || "",
    firstName: response.caseManager?.firstName || "N/A",
    lastName: response.caseManager?.lastName || "N/A",
    categoryName: response.category?.name || null,
    subCategoryName: response.subCategory?.name || null,
    createdAt: response.createdAt,
    documents: response.documents || [],
    isUrgent: response.isUrgent ?? false,
    foundBy: response.foundBy || null,
    foundDate: response.foundDate || null,
    isPendingRequest: response.isPendingRequest ?? false,
    requestType: response.requestType || null,
    itemNumber: response.itemNumber || null,
    isEmailCommunication: response.isEmailCommunication ?? false,
    isSticky: response.isSticky ?? false,
    isFoundItem: response.isFoundItem ?? false,
    location: response.location?.name || null,
    ship: response.ship?.name || null,
    caseManagerName: response.caseManager?.firstName || null,
    isPaymentSuccess: response.isPaymentSuccess || false,
    shippingOptions: response.shippingOptions || [],
    hasShippingProof: response.hasShippingProof || false,
    deliveryDate: response.deliveryDate || null,
    establishmentTypeIcon: response.establishmentTypeIcon || "",
    establishmentType: response.establishmentType || "",
  };
}
